import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { ProductPricingService } from '@usf/ngrx-pricing';
import { IPromotionState, selectPromotionState } from '@usf/ngrx-promotions';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AllDealsResolverService {
  constructor(
    private productPricingService: ProductPricingService,
    private store: Store,
  ) {}

  resolve() {
    // Get prices for promotional products
    return this.store.select(selectPromotionState).pipe(
      filter((promotionState: IPromotionState) => promotionState.loaded),
      tap((promotionState: IPromotionState) => {
        const productNumbers: number[] = [];
        promotionState.ids.forEach(id => {
          productNumbers.push(id);
        });
        this.productPricingService.getPrices(productNumbers);
      }),
    );
  }
}
